// @flow @format
const KB = 1024;
const MB = 1024 * 1024;
const GB = 1024 * 1024 * 1024;
const TB = 1024 * 1024 * 1024 * 1024;

export function toSIString(num: number, unit: string = 'B'): string {
	if (num > TB) {
		return (num / TB).toFixed(2) + 'T' + unit;
	}

	if (num > GB) {
		return (num / GB).toFixed(2) + 'G' + unit;
	}

	if (num > MB) {
		return (num / MB).toFixed(2) + 'M' + unit;
	}

	if (num > KB) {
		return (num / KB).toFixed(2) + 'K' + unit;
	}

	return num + unit;
}

export function toPercentage(a: number, b: number, n: number = 2): string {
	if (a === 0 || b === 0) {
		return '0%';
	}

	return (a / b * 100).toFixed(n) + '%';
}



// WEBPACK FOOTER //
// ./src/lib/util/index.js